var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlarm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#alarm_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D6B100",
  d: "M18 31.17a4.851 4.851 0 1 0 0-9.703 4.851 4.851 0 0 0 0 9.703"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE560",
  d: "M18.004 5.762c5.117 0 9.271 4.155 9.271 9.272v9.27H8.735v-9.27c0-5.117 4.154-9.272 9.27-9.272z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE560",
  d: "M29.21 26.016c.374.88-.271 1.856-1.227 1.856H8.018a1.333 1.333 0 0 1-1.227-1.857l1.94-4.55h18.54z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "M23.914 11.297a3.773 3.773 0 1 0 0-7.546 3.773 3.773 0 0 0 0 7.546"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE560",
  d: "M18.004 9.154a2.254 2.254 0 1 0 0-4.507 2.254 2.254 0 0 0 0 4.507"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "alarm_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6 3.75h24v27.42H6z"
})))));
export default SvgAlarm;